import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19f63014"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "context-menu"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "context-title" }, "Quantidade", -1 /* HOISTED */))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "edit-quantity"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "plus-minus unselectable",
    onMouseleave: _cache[7] || (_cache[7] = ($event: any) => {$setup.showingContextMenu = false; $setup.showingEditQuantity = false}),
    style: _normalizeStyle($props.style)
  }, [
    ($props.packageAmount >= $props.amount)
      ? (_openBlock(), _createBlock($setup["FontAwesomeIcon"], {
          key: 0,
          icon: $setup.Icons.imported.faTrash,
          class: "control-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove-from-cart', $event)))
        }, null, 8 /* PROPS */, ["icon"]))
      : _createCommentVNode("v-if", true),
    ($props.packageAmount < $props.amount)
      ? (_openBlock(), _createBlock($setup["FontAwesomeIcon"], {
          key: 1,
          icon: $setup.Icons.imported.faMinus,
          class: "control-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('add-amount', -$props.packageAmount, $event)))
        }, null, 8 /* PROPS */, ["icon"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: "context-menu-open-btn",
      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showingContextMenu = !$setup.showingContextMenu))
    }, [
      _createElementVNode("p", null, _toDisplayString($props.amount), 1 /* TEXT */),
      _createVNode($setup["FontAwesomeIcon"], {
        icon: $setup.Icons.imported.faCaretDown,
        class: "caret-down"
      }, null, 8 /* PROPS */, ["icon"])
    ]),
    _createVNode($setup["FontAwesomeIcon"], {
      icon: $setup.Icons.imported.faPlus,
      class: "control-button",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('add-amount', +$props.packageAmount, $event)))
    }, null, 8 /* PROPS */, ["icon"]),
    ($setup.showingContextMenu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
            return _createElementVNode("p", {
              class: "context-option",
              onClick: ($event: any) => {_ctx.$emit('set-amount', $setup.getAmount(i), $event); $setup.showingContextMenu = false; $setup.showingEditQuantity = false;},
              key: i
            }, _toDisplayString($setup.getAmount(i)), 9 /* TEXT, PROPS */, _hoisted_3)
          }), 64 /* STABLE_FRAGMENT */)),
          (!$setup.showingEditQuantity)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "context-option",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showingEditQuantity = true))
              }, "Digitar quantidade específica"))
            : _createCommentVNode("v-if", true),
          ($setup.showingEditQuantity)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode($setup["CommonInput"], {
                  type: "number",
                  "model-value": $setup.editingValue,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = (value) => $setup.editingValue = value),
                  onKeyDown: _cache[6] || (_cache[6] = (evt) => {
            if (evt.key === 'Enter') {
              const value = (evt.target as HTMLInputElement).value;
              _ctx.$emit('set-amount', parseFloat(value), null);
              $setup.showingEditQuantity = false;
              $setup.editingValue = '';
            }
          })
                }, null, 8 /* PROPS */, ["model-value"])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 36 /* STYLE, NEED_HYDRATION */))
}